import preset from '../preset';

export const boxTextColorClass = preset.pclasses('boxTextColor');

export default boxTextColorClass;
